import { useEffect, useCallback, KeyboardEventHandler } from 'react';
import { useStore } from '@ui/hooks/useStore';
import useKeyDown from '@ui/hooks/useKeyDown';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const useDeleteSubuser = (onClose: ICloseEvent['onClose']) => {
    const { subusers, lang } = useStore();
    const key = useKeyDown();

    const handleConfirmClick = useCallback(() => {
        subusers.resetServerError();
        subusers.delete();
    }, []);
    const handleBtnKeyDown: KeyboardEventHandler<HTMLElement> = useCallback(
        (e) => {
            const { key } = e;
            if (key === 'Enter') {
                e.stopPropagation();
                e.preventDefault();
                const target = e.target as HTMLElement;
                target.click();
            }
        },
        [],
    );
    const handlers = {
        handleConfirmClick,
        handleBtnKeyDown,
    };

    useEffect(() => {
        subusers.resetServerError();
        if (subusers.operationSuccess) {
            subusers.resetOperationSuccess();
        }
    }, []);
    useEffect(() => {
        if (subusers.operationSuccess) {
            onClose();
            subusers.resetOperationSuccess();
        }
    }, [subusers.operationSuccess]);
    useEffect(() => {
        switch (key) {
            case 'Escape':
                onClose();
                break;
            case 'Enter':
                handleConfirmClick();
                break;
        }
    }, [key]);
    useEffect(() => {
        if (!subusers.selectedSubuser && !subusers.loading) onClose();
    }, [subusers.selectedSubuser, subusers.loading]);

    return {
        subusers,
        lang,
        handlers,
    };
};

export default useDeleteSubuser;
